import React from "react";
import { Box } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { setCurrentTab } from "state";
import CustomTab from "components/Tabs/Tab";
import PeriodLogs from "./periodLogs";
import PaymentLogs from "./paymentLogs";




const SystemLogsTab = () => {
    const dispatch = useDispatch();
    const [value, setValue] = React.useState(useSelector((state)=> state.currentTab['systemLogsTab']) );
    const handleChange = (event, newValue) => {
        setValue(newValue);
        dispatch(setCurrentTab({ name: "systemLogsTab", tab: newValue }));
    };

    const tabComponents = [
      { Component: <PeriodLogs/>, label: "Period Error Logs", index: 0 },
      { Component: <PaymentLogs/>, label: "Payment Error Logs", index: 1 },
    ]; 


    return (
        <Box>
            <CustomTab tabComponents={tabComponents} value={value} handleChange={handleChange}/> 
        </Box>
    )

}

export default SystemLogsTab;